import { useParams } from 'react-router-dom';
import { startCase } from 'lodash';
import { PageLayout } from '../../PageLayout';
import { PageCard } from '../../Compounds/CardWithTitle';
import { Text } from '../../Atoms/Text';
import { getFormattedDate } from '../../../utils/helpers';

export const ErrorPage = () => {
  const { object, code, objectId, timestamp } = useParams();

  const objectName = startCase(object);

  const getAssetErrorLabel = (statusCode: number): string => {
    if (statusCode === 400) {
      return `Invalid ${objectName} request`;
    } else if (statusCode === 401 || statusCode === 403) {
      return `You are not authorized to view this ${objectName}`;
    } else if (statusCode === 404) {
      return `${objectName} Not Found`;
    } else if (statusCode >= 400 && statusCode < 500) {
      return 'Client error';
    } else if (statusCode >= 500 && statusCode < 600) {
      return 'Server error';
    } else {
      return `Unexpected error (code: ${statusCode})`;
    }
  };

  return (
    <PageLayout
      dataTestId="error-page"
      pageTitle={getAssetErrorLabel(Number(code))}>
      <PageCard
        className="mt-5"
        title={`Error ${code}`}>
        <div className="flex flex-row justify-between px-5 py-6">
          <div className="w-1/2 flex flex-col">
            <Text
              size="sm14"
              color="grey6"
              className="mb-2">
              Requested UPSTACK ID
            </Text>
            <Text
              size="sm14"
              color="grey9">
              {objectId}
            </Text>
          </div>
          <div className="w-1/2 flex flex-col">
            <Text
              size="sm14"
              color="grey6"
              className="mb-2">
              Requested At
            </Text>
            <Text
              size="sm14"
              color="grey9">
              {getFormattedDate(Number(timestamp), 'lll (Z)')}
            </Text>
          </div>
        </div>
      </PageCard>
    </PageLayout>
  );
};
